module.exports = __webpack_public_path__ + "img/iconfont.c225ae42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.svg?t=1571105669105
// module id = JisM
// module chunks = 240